import type { SVGProps } from 'react';

export type IconName =
  | 'arrow'
  | 'account'
  | 'bag'
  | 'play'
  | 'pause'
  | 'download'
  | 'key'
  | 'shield'
  | 'headphones'
  | 'spark'
  | 'menu'
  | 'close'
  | 'chevron'
  | 'mail'
  | 'external'
  | 'check'
  | 'clock'
  | 'waveform'
  | 'sliders'
  | 'globe'
  | 'cube';

type IconProps = SVGProps<SVGSVGElement> & { name: IconName };

export function Icon({ name, ...props }: IconProps) {
  const common = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
  };

  const path = (() => {
    switch (name) {
      case 'arrow':
        return <><path d="M5 12h14" /><path d="m14 7 5 5-5 5" /></>;
      case 'account':
        return <><circle cx="12" cy="8" r="3.25" /><path d="M5.5 20c.7-4 3-6 6.5-6s5.8 2 6.5 6" /></>;
      case 'bag':
        return <><path d="M5 8h14l-1 12H6L5 8Z" /><path d="M9 9V6a3 3 0 0 1 6 0v3" /></>;
      case 'play':
        return <path d="m9 6 9 6-9 6V6Z" fill="currentColor" stroke="none" />;
      case 'pause':
        return <><path d="M9 7v10" /><path d="M15 7v10" /></>;
      case 'download':
        return <><path d="M12 3v12" /><path d="m7 10 5 5 5-5" /><path d="M5 21h14" /></>;
      case 'key':
        return <><circle cx="8" cy="15" r="4" /><path d="m11 12 8-8" /><path d="m16 7 2 2" /><path d="m14 9 2 2" /></>;
      case 'shield':
        return <><path d="M12 3 5 6v5c0 4.6 2.8 8 7 10 4.2-2 7-5.4 7-10V6l-7-3Z" /><path d="m9.5 12 1.7 1.7 3.6-4" /></>;
      case 'headphones':
        return <><path d="M4 14v-2a8 8 0 0 1 16 0v2" /><path d="M4 14h3v6H5a1 1 0 0 1-1-1v-5Z" /><path d="M20 14h-3v6h2a1 1 0 0 0 1-1v-5Z" /></>;
      case 'spark':
        return <><path d="m12 3 1.2 4.2L17 9l-3.8 1.8L12 15l-1.2-4.2L7 9l3.8-1.8L12 3Z" /><path d="m18.5 14 .7 2.3 2.3.7-2.3.7-.7 2.3-.7-2.3-2.3-.7 2.3-.7.7-2.3Z" /></>;
      case 'menu':
        return <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>;
      case 'close':
        return <><path d="m6 6 12 12" /><path d="m18 6-12 12" /></>;
      case 'chevron':
        return <path d="m9 6 6 6-6 6" />;
      case 'mail':
        return <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m4 7 8 6 8-6" /></>;
      case 'external':
        return <><path d="M14 4h6v6" /><path d="m20 4-9 9" /><path d="M18 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6" /></>;
      case 'check':
        return <path d="m5 12 4 4L19 6" />;
      case 'clock':
        return <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>;
      case 'waveform':
        return <><path d="M3 12h2l2-6 3 12 3-15 3 12 2-3h3" /></>;
      case 'sliders':
        return <><path d="M4 6h8" /><path d="M16 6h4" /><circle cx="14" cy="6" r="2" /><path d="M4 12h3" /><path d="M11 12h9" /><circle cx="9" cy="12" r="2" /><path d="M4 18h10" /><path d="M18 18h2" /><circle cx="16" cy="18" r="2" /></>;
      case 'globe':
        return <><circle cx="12" cy="12" r="9" /><path d="M3 12h18" /><path d="M12 3a14 14 0 0 1 0 18" /><path d="M12 3a14 14 0 0 0 0 18" /></>;
      case 'cube':
        return <><path d="m12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Z" /><path d="m4 7.5 8 4.5 8-4.5" /><path d="M12 12v9" /></>;
    }
  })();

  return <svg {...common} {...props}>{path}</svg>;
}
